import {Component, Input} from '@angular/core';
import { environment } from '../../../../environments/environment';

import { BandModel } from '../../models/band-model';
import { BandPresentation, presentationOf } from '../../models/band-presentation';
import { BandStatus } from '../../models/band-status';

@Component({
  selector: 'app-show-avatar-band',
  templateUrl: './show-avatar-band.component.html',
  styleUrls: ['./show-avatar-band.component.scss']
})
export class ShowAvatarBandComponent {
  @Input() link: string;
  @Input() size: string;
  @Input() role: string;
  @Input() imei;
  /**
   * Model wyliczony przez rodzica — z getBandType na ekranach szczegolowych albo
   * z pola `type` w wierszu listy. Komponent nie rozpoznaje juz opaski sam: wczesniej
   * porownywal stringi 'VITAL CARE'/'ONE' i trzymal wlasna kopie reguly Plannera
   * (prefiks IMEI 644), przez co nieznany model byl nieodrozninalny od Care Pro.
   */
  @Input() model: BandModel = 'UNKNOWN';
  @Input() resizePlanner = false;
  @Input() colour: string;
  @Input() border = false;
  @Input() bandStatus: BandStatus = 'worn';

  get avatar() {
    return `${environment.avatar_url}${this.link}`;
  }

  get presentation(): BandPresentation {
    return presentationOf(this.model);
  }

  get isPlanner(): boolean {
    return this.model === 'PLANNER';
  }

  /** Ikonki rodziny ONE maja wlasne klasy rozmiaru — patrz BandPresentation.avatarSizing. */
  get avatarClass(): string {
    if (this.presentation.avatarSizing === 'one') {
      if (this.size === 'smallest') { return 'avatar smallest-one'; }
      if (this.size === 'small') { return 'avatar small-one'; }
      return 'avatar';
    }
    return ('avatar ' + (this.size || '')).trim();
  }
}
